import axios from 'axios'
import createAuthRefreshInterceptor from 'axios-auth-refresh'
import HttpStatus from 'http-status-codes'

import ApiTokenRefresh from '@js/api/token-refresh'
import { calculateExpirationTime } from '@js/date-utils'
import store from '@store/store'

const client = axios.create(
  {
    baseURL: process.env.VUE_APP_API_SERVER_BASE_URL + ':' + process.env.VUE_APP_API_SERVER_PORT,
  }
);

client.defaults.headers.common['Content-Type'] = 'application/json';
client.defaults.headers.common['X-XSS-Protection'] = '1; mode=block';

async function refreshAuthCall(failedRequest) {
  try {
    const payload = {
      refresh: store.state.auth.refresh,
    };
    const api = await new ApiTokenRefresh();
    const res = await api.post(payload);
    const tokenPair = await {
      access: res.data.access,
      accessExpiresIn: res.data.accessExpiresIn,
    }
    await store.commit('auth/setAccessToken', tokenPair);
    return Promise.resolve(res);
  } catch (error) {
    return Promise.reject(error);
  }
}

/*
async function refreshAuthCall(failedRequest) {
  try {
    const res = await store.dispatch('auth/refreshAccessToken');
    return Promise.resolve(res);
  } catch (error) {
    return Promise.reject(error);
  }
}
*/

client.interceptors.request.use(request => {
  const access = store.state.auth.access;

  if(request.data) {
    if(request.data.refreshAccessToken) {
      return request;
    }
  }

  if(access) {
    request.headers['Authorization'] = `Bearer ${access}`;
  }

  return request;
});

const axiosAuthRefreshOptions = {
  pauseInstanceWhileRefreshing: false,
  statusCodes: [401, 403, 500],
};

createAuthRefreshInterceptor(client, refreshAuthCall, axiosAuthRefreshOptions);

export default client;
